import { svg } from "lit";
const icon = svg `<path d="M3.5 21.5V8.69225H2.5V2.5H21.5V8.69225H20.5V21.5H3.5ZM4.99998 20H19V8.69225H4.99998V20ZM3.99998 7.1923H20V3.99998H3.99998V7.1923ZM9.1923 13.4326H14.8077V12H9.1923V13.4326Z" fill="currentColor"/>`;
export default icon;
